export default __webpack_public_path__ + "static/testsigma-logo-v3-dark-8fa14130782890e2f4e7aab4befe244a.svg";